module.exports = __webpack_public_path__ + "img/DSCF7246-Edit.1a2b55d0.1a2b55d0.jpg";